export default function ({
                             $config,
                             $axios,
    // error: nuxtError,
                         }) {
    // console.log("baseUrl", $config.baseUrl);
    $axios.setBaseURL($config.baseUrl);
}
